import React from "react";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "./ui/button";
import { useClinic } from "../context/ClinicContext";

const Hero = () => {
  const { clinicInfo } = useClinic();
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center pt-24 bg-[#FAFAF9]"
    >
      <div className="container mx-auto px-8 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left Content */}
          <div className="space-y-10 lg:space-y-12">
            <div className="space-y-6">
              <div className="divider-accent"></div>
              <h1 className="hero-medium text-[#1C1917] leading-tight">
                Welcome to
                <br />
                {clinicInfo.name}
              </h1>
              <p className="body-large text-[#57534E] max-w-xl">
                Family Dental Clinic focused on your overall oral health and
                well-being.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-5 items-start sm:items-center">
              <Button
                onClick={() => scrollToSection("appointments")}
                className="btn-primary group"
              >
                Book an Appointment
                <ArrowRight
                  className="ml-2 w-4 h-4 transition-transform duration-300 group-hover:translate-x-1"
                  strokeWidth={2}
                />
              </Button>

              <button
                onClick={() => scrollToSection("services")}
                className="btn-secondary"
              >
                Explore Services
              </button>
            </div>

            <div className="flex items-start gap-4 pt-6 border-t border-[#E7E5E4]">
              <div className="w-12 h-12 rounded-full bg-[#F5F5F4] flex items-center justify-center flex-shrink-0">
                <Phone size={20} className="text-[#0F766E]" strokeWidth={1.5} />
              </div>
              <div>
                <p className="body-small text-[#78716C] uppercase tracking-wider mb-1">
                  Call us anytime
                </p>
                <a
                  href={`tel:${clinicInfo.phone}`}
                  className="text-xl font-light text-[#1C1917] hover:text-[#0F766E] transition-colors duration-300"
                  style={{
                    fontFamily: "Cormorant, Georgia, serif",
                    letterSpacing: "-0.02em",
                  }}
                >
                  {clinicInfo.phone}
                </a>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-lg shadow-elevated group">
              <img
                src="https://images.unsplash.com/photo-1598256989800-fe5f95da9787?w=800&q=80"
                alt="Modern dental clinic interior"
                className="w-full h-[500px] lg:h-[650px] object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1C1917]/40 to-transparent"></div>
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-8 -left-8 right-8 bg-[#FFFFFF] p-8 shadow-elevated rounded-md border border-[#E7E5E4]">
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 rounded-full bg-[#0F766E] mt-2 flex-shrink-0"></div>
                <p className="body-regular text-[#1C1917] font-light leading-relaxed">
                  American Board Certified dentist utilizing the latest in
                  dental advancements
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Refined Divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px divider-refined"></div>
    </section>
  );
};

export default Hero;
